var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group is-invalid"},[_vm._t("default"),_vm._l((_vm.errors),function(error){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasErrors),expression:"hasErrors"}],key:error.id,staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(error)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }